var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[(_vm.showSubmenu !== false)?_c('q-my-stats-submenu'):_vm._e(),_c('v-row',{staticClass:"mx-7",attrs:{"wrap":""}},[_c('v-card',{staticClass:"full-width"},[_c('q-score-cards-all')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }